export class DynamicExchangeRate {
    constructor(
        public id: number,
        public fromCurrencyName: string,
        public toCurrencyFullName: string,
        public toCurrencyName: string,
        public exchangeRateValue: string,
    ) { }
}